module.exports = __webpack_public_path__ + "img/stick_activites_rando_vtt.3c9f3f5b.svg";